import { createContext } from 'react'

/**
 * True inside a FilterBar's controls. A Select there names what it filters in its own
 * trigger once a value is chosen — "الإدارة: المدراء" rather than a bare "المدراء" that
 * no longer says which filter it is.
 */
export const InFilterBar = createContext(false)
